import { render, staticRenderFns } from "./salesman.vue?vue&type=template&id=32cef6a3&scoped=true"
import script from "./salesman.vue?vue&type=script&lang=js"
export * from "./salesman.vue?vue&type=script&lang=js"
import style0 from "./salesman.vue?vue&type=style&index=0&id=32cef6a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cef6a3",
  null
  
)

export default component.exports